import { clientSlug } from '../utils/clientLogo';

function entry(name, domain) {
  return { name, slug: clientSlug(name), ...(domain ? { domain } : {}) };
}

export const CLIENT_SECTORS = [
  {
    id: 'pharma',
    title: 'Pharmaceuticals & Bio-Technology',
    icon: 'flask',
    accent: 'primary',
    description:
      'Trusted by leading pharmaceutical and biotechnology companies for cleanroom flooring and sterile environment solutions.',
    clients: [
      entry('Zydus Cadila Healthcare Ltd.', 'zyduslife.com'),
      entry('Centaur Pharmaceuticals'),
      entry('Watson Pharma Pvt Ltd'),
      entry('Sanofi India Ltd.', 'sanofi.com'),
      entry('Sava Healthcare Ltd.'),
      entry('Serum Institute of India', 'seruminstitute.com'),
      entry('Venkys India Limited', 'venkys.com'),
      entry('Dr Reddys Laboratories', 'drreddys.com'),
      entry('Fresenius Kabi India', 'fresenius-kabi.com'),
      entry('Abbott India Ltd.', 'abbott.com'),
      entry('Unichem Laboratories', 'unichemlabs.com'),
      entry('Natco Pharma Ltd.', 'natcopharma.com'),
      entry('Marksans Pharma Ltd.', 'marksanspharma.com'),
      entry('Amneal Life Sciences', 'amneal.com'),
      entry('Zydus Lifescience Ltd.', 'zyduslife.com'),
      entry('Indoco Remedies Ltd.', 'indoco.com'),
      entry('Microlabs Ltd.', 'microlabsltd.com'),
      entry('ACG Pam Pharma', 'acg-world.com'),
      entry('Navketan Pharma'),
      entry('Amcor Flexibles India', 'amcor.com'),
      entry('Puniska Injectables'),
      entry('Indus Biotech Ltd.'),
      entry('Datwyler Pharma Packaging', 'datwyler.com'),
      entry('Sophal Pharmaceuticals'),
      entry('CMM Logistics Pvt. Ltd.'),
      entry('Ferrero India Pvt. Ltd.', 'ferrero.com'),
      entry('Knovea Pharmaceutical Ltd.'),
      entry('Symbiotec Pharmaceuticals'),
    ],
  },
  {
    id: 'food',
    title: 'Food & Beverages',
    icon: 'coffee',
    accent: 'secondary',
    description:
      'Providing hygienic, food-grade flooring solutions for leading food processing and beverage manufacturing facilities.',
    clients: [
      entry('Coca-Cola India Ltd.', 'coca-colaindia.com'),
      entry('Nature Delight Dairy'),
      entry('Ferrero India Pvt. Ltd.', 'ferrero.com'),
      entry('IG International Ltd.'),
      entry('Monsanto Holdings', 'bayer.com'),
      entry('Parle Industries Ltd.', 'parleproducts.com'),
      entry('PepsiCo India Ltd.', 'pepsico.com'),
      entry('Venkeys Group', 'venkys.com'),
      entry('Parag Dairy', 'paragmilkfoods.com'),
      entry('Bayer Crop Science', 'bayer.com'),
      entry('Schreiber Dynamix Dairies', 'schreiberfoods.com'),
      entry('Sonai Dairy'),
    ],
  },
  {
    id: 'auto',
    title: 'Automobiles & Engineering',
    icon: 'cog',
    accent: 'primary',
    description:
      'Delivering heavy-duty, industrial-grade flooring solutions for automotive manufacturing and engineering facilities.',
    clients: [
      entry('TATA Advanced Systems', 'tataadvancedsystems.com'),
      entry('ADM Joinflex India'),
      entry('Kalyani Technoforge', 'kalyanitechnoforge.com'),
      entry('Saipro Industries'),
      entry('Mahindra CIE Automotive', 'mahindracie.com'),
      entry('Shri Bhagwant Rubber'),
      entry('Tata Motors Ltd.', 'tatamotors.com'),
      entry('Cilicant Pvt. Ltd.'),
      entry('Renata Precision Components'),
      entry('Highway Industries'),
      entry('Samvardhana Motherson', 'motherson.com'),
      entry('Eka Pak Global India'),
      entry('Naval Dockyard India'),
      entry('Micron Technology Inc.', 'micron.com'),
      entry('Craftsman Automation', 'craftsmanautomation.com'),
      entry('TE Connectivity India', 'te.com'),
      entry('Lumax Industries Ltd.', 'lumaxworld.in'),
      entry('Chheda Electricals'),
      entry('Asian Paints Ltd.', 'asianpaints.com'),
      entry('Packtime Innovations'),
      entry('Atlas Copco', 'atlascopco.com'),
      entry('Ashok Leyland Ltd.', 'ashokleyland.com'),
      entry('Siemens Ltd.', 'siemens.com'),
      entry('Cummins India Ltd.', 'cummins.com'),
      entry('Metaforge Engineering'),
    ],
  },
];

/** Six logo slots per industry — shown in one row under each sector heading */
export const SECTOR_LOGO_ROW_SLUGS = {
  pharma: [
    'zydus-cadila-healthcare-ltd',
    'centaur-pharmaceuticals',
    'watson-pharma-pvt-ltd',
    'sanofi-india-ltd',
    'sava-healthcare-ltd',
    'serum-institute-of-india',
  ],
  food: [
    'coca-cola-india-ltd',
    'ferrero-india-pvt-ltd',
    'parle-industries-ltd',
    'pepsico-india-ltd',
    'venkeys-group',
    'bayer-crop-science',
  ],
  auto: [
    'tata-motors-ltd',
    'mahindra-cie-automotive',
    'asian-paints-ltd',
    'micron-technology-inc',
    'te-connectivity-india',
    'samvardhana-motherson',
  ],
};

export function getSectorLogoRow(sector) {
  const slugs = SECTOR_LOGO_ROW_SLUGS[sector.id] || [];
  const picked = slugs
    .map((slug) => sector.clients.find((c) => c.slug === slug))
    .filter(Boolean);
  if (picked.length >= 6) return picked.slice(0, 6);
  const used = new Set(picked.map((c) => c.slug));
  const fill = sector.clients.filter((c) => !used.has(c.slug));
  return [...picked, ...fill].slice(0, 6);
}

export function getSectorRemainingClients(sector) {
  const logoRow = new Set(getSectorLogoRow(sector).map((c) => c.slug));
  return sector.clients.filter((c) => !logoRow.has(c.slug));
}

export const FEATURED_CLIENT_SLUGS = [
  'zydus-cadila-healthcare-ltd',
  'sanofi-india-ltd',
  'serum-institute-of-india',
  'dr-reddys-laboratories',
  'abbott-india-ltd',
  'coca-cola-india-ltd',
  'pepsico-india-ltd',
  'ferrero-india-pvt-ltd',
  'tata-motors-ltd',
  'asian-paints-ltd',
  'micron-technology-inc',
  'te-connectivity-india',
];

export function getFeaturedClients() {
  const bySlug = new Map();
  CLIENT_SECTORS.forEach((sector) => {
    sector.clients.forEach((client) => {
      bySlug.set(client.slug, client);
    });
  });
  return FEATURED_CLIENT_SLUGS.map((slug) => bySlug.get(slug)).filter(Boolean);
}

export function getTotalClientCount() {
  const slugs = new Set();
  CLIENT_SECTORS.forEach((sector) => {
    sector.clients.forEach((c) => slugs.add(c.slug));
  });
  return slugs.size;
}
